import StyledInput from 'components/styledInput/StyledInput';

/**
 * The menu that picks whose part of a group to read: `allLabel` (value
 * 'all'), then each of `sources` [{ id, label }] (the group alone, its
 * companies). `onChange(value)` gets the id picked, or 'all'. It shrinks
 * before what sits beside it (« Ajouter ») and cuts a long name.
 */
const RecordSourceSelect = ({ value, sources, allLabel, onChange }) => (
  <div className="w-64 min-w-0">
    <StyledInput
      type="select"
      value={value}
      list={[
        { value: 'all', label: allLabel },
        ...sources.map((one) => ({ value: one.id, label: one.label })),
      ]}
      onChange={(event) => onChange(event.target.value)}
    />
  </div>
);

export default RecordSourceSelect;
